import React, {FC, useState} from "react"

import {FormattedMessage} from "@irati/utils/lang"
import {H5, Body} from "@irati/ui/src/Typography"

import {Toggle} from "@irati/ui/src/FormItem"
import Spacing from "@irati/ui/src/Spacing"
import Flex from "@irati/ui/src/Flex"
import authentication from "@irati/auth"
import {UpdateBusinessInput} from "@irati/types"
import businessService from "@irati/identity/services/business"
import adminTracking from "@irati-tracking/admin"

const SSO_TOGGLE_LOGIN = "SSO_toggleNormalLogin"

interface Props {}

const LoginViaEmailPassword: FC<Props> = () => {
  const [showPasswordLogin, setShowPasswordLogin] = useState<boolean>(authentication.business().showPasswordLogin)

  const handleToggle = () => {
    adminTracking.editIntegrationSSOJourney(SSO_TOGGLE_LOGIN)
    const data: UpdateBusinessInput = {
      uuid: authentication.business().uuid,
      showPasswordLogin: !showPasswordLogin
    }
    businessService.update({data}).then(() => {
      setShowPasswordLogin(!showPasswordLogin)
    })
  }

  return (
    <Flex justifyContent="space-between" marginBottom={4}>
      <Spacing marginBottom={2}>
        <H5 marginBottom={1}>
          <FormattedMessage id="admin.components.integration.sso.editSSO.edit.toggleTitle" />
        </H5>
        <Body>
          <FormattedMessage id="admin.components.integration.sso.editSSO.edit.toggleSubTitle" />
        </Body>
      </Spacing>
      <Toggle icons={false} checked={showPasswordLogin} onClick={handleToggle} />
    </Flex>
  )
}

export default LoginViaEmailPassword
